<div class="wrapper">
  <div class="header">
    <debtor-panel-menu></debtor-panel-menu>
  </div>
  <div class="body">
      <mat-spinner [class]="spinnerService.isLoading() ? 'spinner-overlay show' : 'spinner-overlay hide'"></mat-spinner>
      <div  [class]="spinnerService.isLoading() ? 'hide' : 'show main-wrapper'">
        <router-outlet/>
      </div>
  </div>
  <div class="footer">
    <debtor-panel-footer
      [transparent]="false"
      (navigateToOrderContact)="navigateToOrderContact()"
    />
  </div>
</div>
